import './style.scss';

export function faqs_block() {
    const blocks = document.querySelectorAll('.faqs_block');
    if (!blocks.length) return;
    blocks.forEach((block) => {


        let currentAccordionListener = null;

        // region accordion
        function addAccordionListener(contentBlock) {
            const accordion = contentBlock.querySelector(".accordion");

            if (!accordion) return;

            const handleAccordionClick = (e) => {
                const activePanel = e.target.closest(".accordion-panel");
                if (!activePanel) return;
                toggleAccordion(activePanel, contentBlock);
            };

            accordion.addEventListener("click", handleAccordionClick);
            currentAccordionListener = {accordion, handleAccordionClick};
        }

        function toggleAccordion(panelToActivate, contentBlock) {
            contentBlock.querySelectorAll(".accordion-panel").forEach((panel) => {
                const button = panel.querySelector("button");
                const content = panel.querySelector(".accordion-content");

                if (panel !== panelToActivate) {
                    button.setAttribute("aria-expanded", false);
                    content.setAttribute("aria-hidden", true);
                }
            });

            const activeButton = panelToActivate.querySelector("button");
            const activePanel = panelToActivate.querySelector(".accordion-content");
            const isOpened = activeButton.getAttribute("aria-expanded");

            if (isOpened === "true") {
                activeButton.setAttribute("aria-expanded", false);
                activePanel.setAttribute("aria-hidden", true);
            } else {
                activeButton.setAttribute("aria-expanded", true);
                activePanel.setAttribute("aria-hidden", false);
            }
        }

        addAccordionListener(block);

        // endregion
    })
}
